import { ColumnFiltersState, PaginationState, SortingState } from '@tanstack/react-table'
import { useState } from 'react'
import { DateRange } from 'react-day-picker'

const useTableState = (pageSize?: number) => {
  const [sorting, setSorting] = useState<SortingState>([])
  const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([])
  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: 0,
    pageSize: pageSize ?? 10,
  })
  const [dateGlobal, setDateGlobal] = useState<DateRange | undefined>({
    from: undefined,
    to: undefined,
  })

  return {
    columnFilters,
    dateGlobal,
    pagination,
    setColumnFilters,
    setDateGlobal,
    setPagination,
    setSorting,
    sorting,
  }
}

export { useTableState }
